import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/policies/components/PrivacyPolicySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/policies/components/RefundCancellationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/policies/components/TermsOfServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/common/Header.tsx");
